import axios from 'axios';
import { stringify } from 'qs';
import { getStore } from '../store';

export const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

const attachCommonHeaders = async config => {
  config.paramsSerializer = function (params) {
    return stringify(params, { arrayFormat: 'indices' });
  };
  config.headers['Accept'] = 'application/json';
  config.headers['Content-Type'] = 'application/json';
  config.headers['X-Client-Store-Token'] =
    process.env.REACT_APP_SHOPIFY_STORE_API_PUBLIC_TOKEN || '';
  config.headers['X-Client-Org-Id'] = getStore().getState().orgContext.orgId ?? '';
  return config;
};

publicApi.interceptors.request.use(attachCommonHeaders, error => {
  Promise.reject(error);
});

api.interceptors.request.use(attachCommonHeaders, error => {
  Promise.reject(error);
});
